import { render, staticRenderFns } from "./week.vue?vue&type=template&id=13e03457&scoped=true"
import script from "./week.vue?vue&type=script&lang=js"
export * from "./week.vue?vue&type=script&lang=js"
import style0 from "./week.vue?vue&type=style&index=0&id=13e03457&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e03457",
  null
  
)

export default component.exports